import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem } from '@marriott/mi-ui-library';
import { StyledCheckboxItemDiv } from '../../organisms/SearchResults/index.styles';

export const StyledHotelTypeFilterDiv = styled.div`
  ${rtl`
  padding-top: ${toRem(24)};
  .filter-heading-container {
    margin-bottom: ${toRem(16)};
  }

  ${StyledCheckboxItemDiv} {
    input[type='checkbox'] + label {
        padding-right: 0;
        width: fit-content;
        margin-bottom: 0;
        padding-top: 0;
        padding-bottom: 0;
        padding-left: ${toRem(26)};
        &:before {
          top: 0;
          left:0;
        }
        &:after {
          left: ${toRem(6)};
          top: ${toRem(2)};
        }
    }
  }
  `}
`;
